import { Component, OnInit } from '@angular/core';
import {SharedService} from '../shared-service.service';

@Component({
  selector: 'app-quote-form',
  templateUrl: './quote-form.component.html',
  styleUrls: ['./quote-form.component.css']
})
export class QuoteFormComponent implements OnInit {

  dataToSend: any = [];
  constructor(public shared: SharedService) { }

  ngOnInit() {
  }

}
